import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext, useMemo, useState, } from 'react';
import { ConfigCTX } from '@basket/context/config';
import { Swiper, SwiperSlide } from 'swiper/react';
import UpsellElement from '@basket/components/UpsellList/components';
import { Pagination } from 'swiper';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
import { Wrapper, Title } from './styles';
function UpsellList() {
    const { upsellSwiper } = useContext(ConfigCTX);
    const { upsells } = useContext(ConfigCTX);
    const [addedUpsells, setAddedUpsells] = useState([]);
    const unaddedUpsells = useMemo(() => upsells.filter((upsell) => !addedUpsells.includes(upsell)), [addedUpsells, upsells]);
    const onUpsellAdded = useGlobalEvent('upsell.added');
    onUpsellAdded((ev) => {
        const upsell = upsells.find((curr) => curr.id === ev.detail);
        console.log('Adding upsell: ', {
            id: ev.detail,
            upsell,
        });
        if (upsell) {
            setAddedUpsells([...addedUpsells, upsell]);
        }
    });
    const minWidthForSwiper = 800;
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    window.addEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
    });
    if (unaddedUpsells.length === 0) {
        return null;
    }
    if (upsellSwiper && windowWidth > minWidthForSwiper) {
        return (_jsxs("div", { children: [unaddedUpsells.length > 0 && _jsx(Title, { children: "Wouldn\u2019t want to miss out:" }), _jsx(Swiper, { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 16, modules: [Pagination], pagination: {
                        clickable: true,
                    }, children: unaddedUpsells.map((upsell, upsellIndex) => (_jsx(SwiperSlide, { children: _jsx(UpsellElement, { upsell: upsell, onClick: () => {
                                window.dispatchEvent(new CustomEvent('upsell.open', {
                                    detail: upsell,
                                }));
                            } }, `upsell-${upsellIndex}`) }))) })] }));
    }
    return (_jsxs(Wrapper, { className: "basket__upsells", children: [unaddedUpsells.length > 0 && _jsx(Title, { children: "Wouldn\u2019t want to miss out:" }), unaddedUpsells.map((upsell, upsellIndex) => (_jsx(UpsellElement, { upsell: upsell, onClick: (id) => {
                    window.dispatchEvent(new CustomEvent('upsell.open', {
                        detail: upsell,
                    }));
                } }, `upsell-${upsellIndex}`)))] }));
}
export default UpsellList;
